import { gql, useMutation } from "@apollo/client";

const deleteProtocolMutation = gql`
  mutation DeleteProtocol($id: ID!) {
    deleteProtocol(id: $id)
  }
`;

export const useDeleteProtocol = () => {
  return useMutation(deleteProtocolMutation, { refetchQueries: ["protocols", "allProtocols"] });
};
